<template>
  <div class="login-form" v-autofocus>
    <validation-observer ref="loginObs"
                         tag="form"
                         @submit.prevent="submitLoginForm">
      <img class="logo" src="/assets/images/logo_mobile.svg" width="160" height="44" alt=""/>
      <h2 class="form-title">{{ $t('login.loginForm.loginTitle') }}</h2>
      <div class="form-fields">
        <base-v-input v-model.trim="emailInput"
                      id="email"
                      ref="email"
                      container-class="email-input"
                      name="email"
                      :submitted="loginFormSubmitted"
                      :label="$t('registration.emailLabel')"
                      rules="required|noSpaces|email"
                      vid="email">
        </base-v-input>
        <base-v-input v-model.trim="passwordInput"
                      id="password"
                      container-class="password-input"
                      name="password"
                      rules="required"
                      :submitted="loginFormSubmitted"
                      :label="$t('registration.passwordLabel')"
                      revealPassword
                      type="password"
                      maxlength="20"
                      vid="password"
                      ref="password"/>
        <div class="bottom-wrapper">
          <base-checkbox v-model="rememberMe" variant="red" class="login-checkbox" required>
            {{ $t('login.loginForm.rememberMeLabel') }}
          </base-checkbox>
          <a class="back-link" :href="forgottenPasswordLink" @click="forgottenPasswordEvent">{{ $t('registration.forgotPassword') }}</a>
        </div>
        <base-button :disabled="!loginFormFilled || buttonDisabled"
                     :loading="dataLoading"
                     class="login-btn"
                     type="submit">
          {{ $t('common.signUp') }}
        </base-button>
        <span class="strong-text">{{ $t('login.loginForm.noAccountLabel') }} <a class="back-link" :href="registrationPageLink"> {{ $t('login.loginForm.register') }}</a></span>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { addDataLayerEvent } from '@/services/dataLayer'
import { customRouter } from '@/customRouter'
import { LOGIN_COOKIE_NAME } from '@/services/securityCookieHandler'
import { addUserIdDataLayerEvent } from '@/utils/addUserIdDataLayerEvent'

export default {
  name: 'login-form',
  data () {
    return {
      emailInput: '',
      passwordInput: '',
      loginFormSubmitted: false,
      rememberMe: false,
      buttonDisabled: false,
      dataLoading: false,
      autofilled: false
    }
  },
  computed: {
    loginFormFilled () {
      return (!!this.emailInput && !!this.passwordInput) || this.autofilled
    },
    forgottenPasswordLink () {
      return customRouter.getRouteByName({ name: 'forgottenPassword' })
    },
    registrationPageLink () {
      return customRouter.getRouteByName({ name: 'registration' })
    }
  },
  methods: {
    forgottenPasswordEvent () {
      addDataLayerEvent('zaboravljena_lozinka')
    },
    async submitLoginForm () {
      this.loginFormSubmitted = true
      this.buttonDisabled = true
      const valid = await this.$refs.loginObs.validate()

      if (valid) {
        const formData = new FormData()
        formData.append('userId', this.emailInput)
        formData.append('encodedPassword', this.passwordInput)
        formData.append('rememberMe', this.rememberMe)
        this.$mvcRequest.post('users/authorize', formData)
          .then(response => {
            this.buttonDisabled = false
            if (response.status >= 200 && response.status < 400) {
              this.$cookies.set(LOGIN_COOKIE_NAME, true, 30)
              addUserIdDataLayerEvent()
              addDataLayerEvent({ event: 'login_successful' })
              customRouter.goTo({ name: 'servicesOverview' })
            }
          })
          .catch(e => {
            this.toast('error', {
              message: e.response.data.response.Errors[0].Message
            })
            this.buttonDisabled = false
            if (e.response.status === 400) {
              // wrong username or password
              addDataLayerEvent({
                reason: 'info',
                event: 'login_failed'
              })
            } else {
              addDataLayerEvent({
                reason: 'login',
                event: 'login_failed'
              })
            }
          })
      } else {
        this.buttonDisabled = false
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        const emailInputColorCheck = window.getComputedStyle(document.querySelector('#email'), null).getPropertyValue('background-color')
        const passwordInputColorCheck = window.getComputedStyle(document.querySelector('#email'), null).getPropertyValue('background-color')
        if (emailInputColorCheck !== 'rgb(241, 242, 243)' && passwordInputColorCheck !== 'rgb(241, 242, 243)') {
          this.autofilled = true
        }
      }, 600)
    })
  }
}
</script>

<style scoped lang="scss" src="./login-comp-styles/login-form.scss"></style>
